import React, { Fragment } from "react";
import ContentLoader from "react-content-loader";

interface TableSkeletonProps {
  numRows?: number;
  width?: number;
  horizontalBuffer?: number;
  numColumns?: number;
}

export const TableSkeleton: React.FC<TableSkeletonProps> = ({
  numRows = 10,
  numColumns = 10,
  width = 1500,
  horizontalBuffer = 20,
}: TableSkeletonProps) => {
  const rowHeight = 60;
  const titleRx = 5;
  const titleRy = 5;
  const bodyRx = 4;
  const bodyRy = 4;
  const halfSpacing = horizontalBuffer / 2;
  const columnHighlightWidth = width / numColumns - halfSpacing;

  const headerLoader = (
    <ContentLoader
      viewBox={`0 0 ${width} ${rowHeight}`}
      backgroundColor="var(--background-gray)"
      foregroundColor="var(--border-gray-light)"
    >
      <rect
        x="0"
        y="30"
        rx={titleRx}
        ry={titleRy}
        width={width}
        height={rowHeight / 2}
      />
    </ContentLoader>
  );
  function createBodyRows() {
    const rows = [];
    for (let i = 0; i < numRows; i++) {
      const contentVerticalPosition = (contentHeight: number) =>
        numRows > 1 ? contentHeight + rowHeight * i : contentHeight;
      rows.push(
        <Fragment key={i}>
          {createBodyColumns(contentVerticalPosition)}
        </Fragment>,
      );
    }
    return rows;
  }
  function createBodyColumns(
    contentVerticalPosition: (contentHeight: number) => number,
  ) {
    const columns = [];
    for (let i = 0; i < numColumns; i++) {
      if (i === 0) {
        columns.push(
          <rect
            x="0"
            y={`${contentVerticalPosition(20)}`}
            rx={bodyRx}
            ry={bodyRy}
            width={columnHighlightWidth}
            height={`${rowHeight / numColumns}`}
            key={i}
          />,
        );
      } else {
        columns.push(
          <rect
            x={(width / numColumns) * i + halfSpacing}
            y={`${contentVerticalPosition(20)}`}
            rx={bodyRx}
            ry={bodyRy}
            width={columnHighlightWidth}
            height={`${rowHeight / numColumns}`}
            key={i}
          />,
        );
      }
    }
    return columns;
  }
  return (
    <div>
      {headerLoader}
      <ContentLoader viewBox={`0 0 ${width} ${rowHeight * numRows}`}>
        {createBodyRows()}
      </ContentLoader>
    </div>
  );
};
